import { useEffect, useRef } from 'react'
import { useFnsServiceGetFormsForAdminQuery } from 'zma-react-sdk/fns-service'
import { useTenantStore } from '@/stores/tenantStore'
import { useFnsMode } from '@/features/forms-and-surveys/hooks'

interface UseFormsParams {
  limit: number
  skip: number
}

function useForms(pagination: UseFormsParams) {
  const { selectedTenantId } = useTenantStore()
  const mode = useFnsMode()
  const tenantRef = useRef(selectedTenantId)

  const query = useFnsServiceGetFormsForAdminQuery({
    skip: mode === 'survey' || selectedTenantId === null,
    variables: {
      pagination: {
        limit: pagination.limit,
        skip: pagination.skip,
      },
    },
    context: {
      headers: {
        'x-tenant-id': selectedTenantId,
      },
    },
  })

  useEffect(() => {
    if (
      selectedTenantId &&
      selectedTenantId !== tenantRef.current &&
      query.refetch
    ) {
      query.refetch()
    }
    tenantRef.current = selectedTenantId
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTenantId, query.refetch])

  return query
}

export { useForms }
